import dayjs from 'dayjs';
import qs from 'qs';

const state = {
    query: {
        start_date: dayjs().subtract(3, 'month').format('YYYY-MM-DD'),
        end_date: dayjs().format('YYYY-MM-DD'),
    },
};

const actions = {
    getLocationSearch({ commit }) {
        commit('parseQuerystring');
        commit('updateQuery');
    },
};

const mutations = {
    parseQuerystring(state) {
        const queryString = qs.parse(window.location.search, {
            encode: false,
            ignoreQueryPrefix: true,
        });

        state.query = Object.assign(queryString);
    },

    updateQuery(state, query) {
        state.query = {
            ...state.query,
            ...query,
        };

        const queryStringified = qs.stringify(state.query, {
            addQueryPrefix: true,
            encode: false,
        });

        window.history.replaceState(
            {},
            '',
            window.location.pathname + queryStringified,
        );
    },
};

export default {
    namespaced: true,
    actions,
    mutations,
    state,
};
